// @flow

import React from "react";
import { connect } from "react-redux";

import LogoutView from "buba-components/src/views/Logout";
import { clearUserData as clearUserDataAction } from "../../store/user/actions";
import paths from "../../data/paths";

type LogoutProps = {
  clearUserData: typeof clearUserDataAction
};

const Logout = ({ clearUserData }: LogoutProps) => (
  <LogoutView clearUserData={clearUserData} loginPath={paths.login} />
);

export default connect(null, { clearUserData: clearUserDataAction })(Logout);
